export function isOnEstimation(pathname: string) {
  if (
    pathname.includes("water-heater") ||
    pathname.includes("direct") ||
    pathname.includes("simplified") ||
    pathname.includes("advanced")
  ) {
    return true;
  }

  return false;
}
